module.exports = __webpack_public_path__ + "assets/images/project/philippines.jpg?v=0ebf6e7f";